import React from "react";

import { Setup } from "@swegon/sds-core";

import { config } from "./config";

export const SdsSetup = ({ children }) => {
    return <Setup config={config}>{children}</Setup>;
};
export default SdsSetup;
